var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-scroll-x-transition',{attrs:{"leave-absolute":""}},[_c('router-view')],1),_c('v-toast'),_c('v-confirmation'),_c('v-alert'),_c('v-authentication')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }